// Common utilities for the YBF dashboard
import { Sparkles, GraduationCap, Sprout, Leaf } from "lucide-react";

export const fmtInt = (n) => {
  if (n == null) return "–";
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(2)}M`;
  if (n >= 1_00_000)   return `${(n / 1_00_000).toFixed(1)}L`;   // Lakh
  if (n >= 1_000)     return `${(n / 1_000).toFixed(1)}k`;
  return n.toLocaleString("en-IN");
};

export const fmtCr = (n) => (n == null ? "–" : `₹${Number(n).toFixed(2)} Cr`);

export const pct = (a, b) => (b ? Math.round((a / b) * 100) : 0);

export const deltaPct = (cur, prev) => {
  if (!prev || prev === 0) return null;
  return ((cur - prev) / prev) * 100;
};

export const PILLAR_ICON = {
  employability: GraduationCap,
  entrepreneurship: Sprout,
  environment: Leaf,
  default: Sparkles,
};
